import { Button, Input, Space, Table, Tag } from "antd";
import Loading from 'layouts/Loading/Loading';
import Axios from 'middleware/axiosInstance';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Foods = () => {
    const navigate = useNavigate();

    const [allFoods, setAllFoods] = useState()
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [searchText, setSearchText] = useState('');

    const getAllFoods = () => {
        Axios.get("/food")
            .then((res) => {
                setAllFoods(res.data)
            })
            .catch(err => console.log(err))
    }

    const clearFilters = () => {
        setFilteredInfo({});
    };

    const clearAll = () => {
        setFilteredInfo({});
        setSortedInfo({});
        setSearchText('');
    };

    const handleChange = (pagination, filters, sorter) => {
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const deleteDoc = (food) => {
        if (window.confirm(`آیا "${food.name_fa}" حذف گردد؟`)) {
            deleteDocHandler(food);
        }
    };

    const deleteDocHandler = (food) => {
        Axios.delete(`food/${food.id}`)
            .then((res) => {
                if (res.status === 204) {
                    getAllFoods()
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
            });
    };

    const goToAddPage = () => {
        navigate("/foods/add")
    }

    const goToSortingPage = () => {
        navigate("/foods/sorting")
    };

    useEffect(() => {
        getAllFoods()
    }, []);

    const columns = [
        {
            title: "نام",
            dataIndex: "name_fa",
            key: "name_fa",
            sorter: (a, b) =>
                a.name_fa > b.name_fa ? 1 : b.name_fa > a.name_fa ? -1 : 0,
            sortOrder: sortedInfo.columnKey === "name_fa" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "دسته بندی",
            dataIndex: "category",
            key: "category",
            render: (_, item) => (
                <span>{item.category?.title_fa}</span>
            ),
            filters: allFoods?.filter((v, i, a) => a.findIndex((v2) => v2.category.id === v.category.id) === i)
                .map((item) => {
                    return {
                        text: item.category.title_fa,
                        value: item.category.title_fa,
                    };
                }),
            filteredValue: filteredInfo.category || null,
            onFilter: (value, record) => record.category.title_fa.includes(value),
            sorter: (a, b) => (a.category.title_fa > b.category.title_fa ? 1 : b.category.title_fa > a.category.title_fa ? -1 : 0),
            sortOrder: sortedInfo.columnKey === "category" ? sortedInfo.order : null,
        },
        {
            title: "وضعیت نمایش در منو",
            dataIndex: "is_available",
            key: "is_available",
            render: (_, item) => (
                <span>{item.is_not_exist ? "✗" : "✔"}</span>
            ),
        }, {
            title: "برچسب‌ها",
            dataIndex: "badges",
            key: "badges",
            render: (_, item) => {
                const b = item.badges?.[0];
                return b ? <Tag key={b.id} color="blue">{b.title_fa}</Tag> : null;
            }
        }, {
            title: "عملیات",
            dataIndex: "action",
            key: "action",
            render: (a, food) => (
                <Space size="small">
                    <Link
                        to={`/foods/edit/${food.id}`}
                        className="btn btn-primary btn-sm"
                    >ویرایش</Link>
                    <button
                        onClick={() => deleteDoc(food)}
                        className="btn btn-danger btn-sm"
                    >حذف</button>
                </Space>
            ),
        },
    ];

    // Filter foods based on search text
    const filteredFoods = allFoods?.filter(food =>
        food.name_fa?.toLowerCase().includes(searchText.toLowerCase())
    ) || [];

    return (
        <div className="customized-container">
            <div className="customized-wrapper">
                <div>
                    <Space style={{ marginBottom: 16 }}>
                        <Button onClick={goToAddPage}>اضافه کردن</Button>
                        <Button onClick={clearFilters}>حذف فیلترها</Button>
                        <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
                        <Button
                            onClick={goToSortingPage}
                        >
                            مرتب‌سازی و ترتیب‌بندی
                        </Button>
                    </Space>

                    {/* Search Input */}
                    <div style={{ marginBottom: 16 }}>
                        <Input.Search
                            placeholder="جستجو بر اساس نام غذا..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            style={{ width: 300 }}
                            allowClear
                        />
                    </div>

                    {allFoods ? (
                        filteredFoods.length > 0 ? (
                            <Table
                                pagination={false}
                                columns={columns}
                                dataSource={filteredFoods}
                                rowKey="id"
                                onChange={handleChange}
                            />
                        ) : searchText ? (
                            <div className='vh-center mt-5'>
                                <h2>نتیجه‌ای برای جستجوی "{searchText}" یافت نشد</h2>
                            </div>
                        ) : (
                            <h2>محتوایی نیست</h2>
                        )) : <Loading />}
                </div>
            </div>
        </div >
    )
}

export default Foods
